import React, {Dispatch, SetStateAction, useState} from 'react';

import {
    FixedLineAccessTechnologyType,
    OfferType,
    TariffOfferType,
    TariffCatalogType,
    CmsPageContentType,
    CmsPageContentIdentifier,
    Commission,
    TariffDisplayPrice, Feature,
} from '@/types/av-check';

import {
    ButtonBeta, PriceFlag, TeaserNeuro,
} from '@/components/compendium';
import OfferPrice from '@/components/av-check/OfferPrice';
import {
    getAvailableTariffs,
    getChargesForTariffOfferGroup,
  getMainTariffOffer,
  getTariffOfferComparator,
    getChargesNatureForTechnologyPricing,
  getTariffNameDetails,
    getTariffName,
  cmsSnippetGenerator,
    interpolate,
    isTariffOfferGroupContainingXXLTariff,
} from '@/utils';
export interface TariffCatalogItemProps {
  stairSchemaClass?: string,
  taroCommissionsShop: boolean,
  taroCommissionsCci: boolean,
  tariffCatalog: TariffCatalogType,
  tariffButtonLabel: string,
  highlightLabel?: string,
  productTypeLabel?: string,
  dslOptionLabel: string,
  coaxOptionLabel: string,
  cmsContent: CmsPageContentType,
  fmsOptionLabel: string,
  availableAsLabel: string,
  upsellLabel: string,
  downsellLabel: string,
  selectedBandwidthMatchLabel: string,
  ftthEarliestAvailabilityDate: string,
  ftthPreconnected: boolean|undefined,
  ftthExpansionStatus: string,
  technologyPricingLabels: { DISCOUNT: string, SURCHARGE: string, MONTHLYLIST: string },
  technologyPricingVariationHintlabels: { DISPLAYED_TARIFF: string, VARIED_TARIFFS: string, VARIATION_HINT_LABEL: string },
  tariffButtonClickEvent: React.MouseEventHandler<HTMLAnchorElement>,
  setFtthModelRedirectionState: Dispatch<SetStateAction<boolean>>,
  displayPrice?:TariffDisplayPrice,
  enabledFeatures?: Feature[],
  isCciTheme: boolean,
}

const TariffCatalogItem = ({
  stairSchemaClass,
  taroCommissionsShop,
  taroCommissionsCci,
  tariffCatalog,
  tariffButtonLabel,
  highlightLabel,
  cmsContent,
  availableAsLabel,
  upsellLabel,
  downsellLabel,
  selectedBandwidthMatchLabel,
  ftthEarliestAvailabilityDate,
  ftthPreconnected,
  ftthExpansionStatus,
  technologyPricingLabels,
  technologyPricingVariationHintlabels,
  tariffButtonClickEvent,
  setFtthModelRedirectionState,
  displayPrice,
  enabledFeatures,
  isCciTheme
}: TariffCatalogItemProps) => {
  const getDefaultSelectedTariffOffer = (): TariffOfferType | undefined => getMainTariffOffer(tariffCatalog);

  const [selectedTariffOffer] = useState<TariffOfferType | undefined>(getDefaultSelectedTariffOffer());
  if (!selectedTariffOffer) {
    return null;
  }

  const {
    tariffVariationCode,
    accessTechnology,
    url,
    offerType,
    cmsTariffDescription,
  } = selectedTariffOffer;

  const availableTariffs = getAvailableTariffs(tariffCatalog).sort(getTariffOfferComparator());
  const selectedAvailableTariffs = getChargesForTariffOfferGroup(availableTariffs);
  const isGroupContainsXXLTariff = isTariffOfferGroupContainingXXLTariff(availableTariffs);
  const { charges } = selectedAvailableTariffs;
  const chargesNature = getChargesNatureForTechnologyPricing(availableTariffs);
  const displayedTariffName = getTariffName(selectedAvailableTariffs.accessTechnology);
  const variedTariffNames = getTariffNameDetails(availableTariffs, selectedAvailableTariffs);
  const displayedTariffVariationHintLabel = interpolate(technologyPricingVariationHintlabels.DISPLAYED_TARIFF, { displayedTariff: displayedTariffName });
  const technologyPricingVariationHintLabel = interpolate(technologyPricingVariationHintlabels.VARIED_TARIFFS, { variedTariffs: variedTariffNames.toString() });
  const TariffVariationHintLabel = cmsSnippetGenerator(displayedTariffName, variedTariffNames.toString(), displayedTariffVariationHintLabel, technologyPricingVariationHintLabel, technologyPricingVariationHintlabels.VARIATION_HINT_LABEL);

  const additionalInfo = `tariffVariationCode: ${tariffVariationCode}, fixedLineAccessTechnology: ${accessTechnology}`;
  const getHeadlineLabel = (identifier?: string): string => {
    if (identifier === OfferType.SELECTED) {
      return selectedBandwidthMatchLabel;
    }
    if (identifier === OfferType.UPSELL) {
      return upsellLabel;
    }
    if (identifier === OfferType.DOWNSELL) {
      return downsellLabel;
    }
    return highlightLabel || '';
  };

    const getIconForAccessTechnology = (fixedLineAccessTechnologyType: FixedLineAccessTechnologyType, commissions: Commission[]) => {
        let taroCommissionsCciVorhanden = (taroCommissionsCci && Array.isArray(commissions) && commissions.length);
        const iconColor = {color: "#91c90e"};
        if (taroCommissionsCciVorhanden) {
            switch (fixedLineAccessTechnologyType) {
                case FixedLineAccessTechnologyType.COAX:
                    return (<span className="h1"><span style={iconColor} className={`glyphicon ${cmsContent[CmsPageContentIdentifier.CoaxTechnologyGlyphiconSolid]}`}/></span>);
                case FixedLineAccessTechnologyType.DSL:
                    return (<span className="h1"><span style={iconColor} className={`glyphicon ${cmsContent[CmsPageContentIdentifier.DslTechnologyGlyphiconSolid]}`}/></span>);
                case FixedLineAccessTechnologyType.FMS:
                    return (<span className="h1"><span style={iconColor} className={`glyphicon ${cmsContent[CmsPageContentIdentifier.FmsTechnologyGlyphiconSolid]}`}/></span>);
                case FixedLineAccessTechnologyType.FTTH:
                    return (<span className="h1"><span style={iconColor} className={`glyphicon ${cmsContent[CmsPageContentIdentifier.FtthTechnologyGlyphiconSolid]}`}/></span>);
                default:
                    return (<span className="h1"/>);
            }
        } else {
            switch (fixedLineAccessTechnologyType) {
                case FixedLineAccessTechnologyType.COAX:
                    return (<span className="h1"><span className={`glyphicon ${cmsContent[CmsPageContentIdentifier.CoaxTechnologyGlyphicon]}`}/></span>);
                case FixedLineAccessTechnologyType.DSL:
                    return (<span className="h1"><span className={`glyphicon ${cmsContent[CmsPageContentIdentifier.DslTechnologyGlyphicon]}`}/></span>);
                case FixedLineAccessTechnologyType.FMS:
                    return (<span className="h1"><span className={`glyphicon ${cmsContent[CmsPageContentIdentifier.FmsTechnologyGlyphicon]}`}/></span>);
                case FixedLineAccessTechnologyType.FTTH:
                    return (<span className="h1"><span className={`glyphicon ${cmsContent[CmsPageContentIdentifier.FtthTechnologyGlyphicon]}`}/></span>);
                default:
                    return (<span className="h1"/>);
            }
        }
    };

  const getAvailableAccessTechnologyIcons = () => (
    <p>
      <strong dangerouslySetInnerHTML={{ __html: availableAsLabel }} />
      <br />
      {(taroCommissionsShop || taroCommissionsCci) ? getCommissionsPrioIcons() : getIconsForTariffs(availableTariffs)}
    </p>
  );

  function getIconsForTariffs(tariffOffers:TariffOfferType[]):JSX.Element[] {
    return tariffOffers.map((tariff) => getIconForAccessTechnology(tariff.accessTechnology, tariff.commissions));
  }

  function getCommissionsPrioIcons() {
    const tariffsWithCommissions = availableTariffs.filter((tariff) => Array.isArray(tariff.commissions) && tariff.commissions.length > 0);
    const tariffsWithoutCommissions = availableTariffs.filter((tariff) => !Array.isArray(tariff.commissions) || tariff.commissions.length == 0);
    return getIconsForTariffs(tariffsWithCommissions.concat(tariffsWithoutCommissions));
  }

  const getAvailableAccessTechnologies = (): string => {
    const accessTechs: string[] = [];
    availableTariffs.map((tariff) => accessTechs.push(tariff.accessTechnology));
    return accessTechs.join(';');
  };

  const isDtagFtthTariff = availableTariffs.length==1 && availableTariffs[0].accessType == 'DTAG-FTTH-ETH';

  const {
    name , shortName , downloadBandwidthWithIcon, downloadBandwidthUnit, pibLink,
  } = cmsTariffDescription;
    const isTariffShortNameToggleEnabled = enabledFeatures?.includes(Feature.DISPLAY_TARIFF_SHORT_NAME);


    return (

    <TeaserNeuro
      indented
      highlight={highlightLabel !== undefined}
      stairSchemaClass={stairSchemaClass}
      headline={(
        <TeaserNeuro.Headline
          topContent={isTariffShortNameToggleEnabled ? shortName.rendered: name.rendered}
          mainContent={downloadBandwidthWithIcon.rendered}
          bottomContent={downloadBandwidthUnit.rendered}
        />
            )}
      subline={getHeadlineLabel(offerType)}
      topline={undefined}
      text={(
        <ul>
          {cmsTariffDescription.features.map((feature, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <li key={index} dangerouslySetInnerHTML={{ __html: feature.rendered }} />
          ))}
        </ul>
            )}
      availableAccessTechnologies={getAvailableAccessTechnologyIcons()}
      ftthEarliestAvailabilityDate={(!ftthPreconnected && ftthPreconnected != undefined) ? ftthEarliestAvailabilityDate : undefined}
      links={<span dangerouslySetInnerHTML={{ __html: pibLink.rendered }} />}
      price={(
        <PriceFlag>
          <OfferPrice
            charges={charges}
            isAvCheckResultsDisplay
            technologyPricingLabels={technologyPricingLabels}
            chargesNature={chargesNature}
            technologyPricingVariationHintLabel={TariffVariationHintLabel}
            cms={cmsContent}
            isGroupContainsXXLTariff = {isGroupContainsXXLTariff}
            displayPrice = {displayPrice}
          />
        </PriceFlag>
              )}
      actionLinks={(
        <ButtonBeta
          block
          linkTextContent={tariffButtonLabel}
          href={availableTariffs.length > 1 ? '#modal-technologieauswahl' : isDtagFtthTariff ? '#modal-technologieauswahlftth' : url}
          selectedTariff={selectedTariffOffer}
          highlighted={highlightLabel !== undefined}
          accessTechs={getAvailableAccessTechnologies()}
          clickFunction={tariffButtonClickEvent}
          setFtthModelRedirectionState={setFtthModelRedirectionState}
          expansionStatusForFtth={ftthExpansionStatus}
          isCciTheme = {isCciTheme}
        />
            )}
      additionalInfo={additionalInfo}
    />
  );
};

export default TariffCatalogItem;
